import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import passwordReset from '../views/ResetPassword.vue'
import EmailBestaetigen from '../views/EmailBestaetigen.vue'
import Einladung from '../views/Einladung.vue'

Vue.use(VueRouter)

const routes = [
  { path: "*", redirect: "/login/login/1" },
  {
    path: '/login/:mode/:redirect/',
    name: 'Login',
    props: true,
    component: Login
  },
  {
    path: '/register/',
    name: 'Register',
    props: true,
    component: Register
  },
  {
    path: '/resetPassword/:id',
    name: 'passwordReset',
    props: true,
    component: passwordReset
  },
  //backend#57: Link aus der Bestaetigungsmail nach der Registrierung
  {
    path: '/emailBestaetigen/:token',
    name: 'EmailBestaetigen',
    props: true,
    component: EmailBestaetigen
  },
  //backend#66: Fahrer setzt sein Passwort selbst - mit Link (token) oder Einmalcode
  {
    path: '/einladung/:token?',
    name: 'Einladung',
    props: true,
    component: Einladung
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
